// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oHcG","badges":"styles_badges__22zw9"};